<script lang="ts">
	import '../app.css';
	import '../font.css';
	import 'tippy.js/dist/tippy.css';
	import 'tippy.js/themes/light.css';
	import 'tippy.js/themes/material.css';
	import 'tippy.js/themes/light-border.css';
	// IMPORTANT: sentry initialization must run before graphdb wiring,
	// so import it BEFORE '$lib/tools/graphdb'. Module import order is
	// guaranteed, so this runs first.
	import '$lib/tools/sentry';

	import RootModal from '$lib/utils/components/RootModal.svelte';
	import Auth from '$lib/features/auth/components/Auth.svelte';
	import NavBar from '$lib/components/NavBar/NavBar.svelte';

	import { auth_state } from '$lib/features/auth/state/auth_state';
	import { locale_state } from '$lib/tools/locale.svelte';
	import { toast, Toasts } from 'svoast';
	import { page } from '$app/state';
	import { onMount } from 'svelte';
	import '$lib/tools/graphdb';
	let { children } = $props();

	onMount(() => {
		try {
			const on_auth_unsub = auth_state.on_auth('/layout', async () => {
				const { initiate_main_states } = await import('$lib/states/initiate_main_states');
				initiate_main_states();
			});
			// H2 insurance: an offline-restored session renders the app without
			// ever firing on_auth — boot the critical states (incl. the managed
			// stores) anyway. initiate_main_states is idempotent.
			if (auth_state.is_authenticated_offline === true) {
				void import('$lib/states/initiate_main_states').then((module) => {
					module.initiate_main_states();
				});
			}
			return on_auth_unsub;
		} catch (error) {
			console.error('error at onmount fn +layout:', error);
		}
	});

	$effect(() => {
		if (!toast.toasts.length) {
			const popover = document.getElementById('popover-toast');
			popover?.hidePopover?.();
		}
	});
</script>

<svelte:head>
	<title>Shaggaga Driver</title>
</svelte:head>

<RootModal />

<div dir={locale_state.dir} class="relative min-h-dvh w-full">
	<div class="flex min-h-screen flex-col">
		<main
			class="flex flex-1 flex-col p-1"
			style="padding-top: calc(0.25rem + env(safe-area-inset-top, 0px)); padding-bottom: calc(3.5rem + env(safe-area-inset-bottom, 0px));"
		>
			{#if auth_state.is_authenticated_offline === true || auth_state.value === true || page.url.pathname === '/privacy' || page.url.pathname === '/debug'}
				{@render children()}
			{:else}
				<Auth />
			{/if}
		</main>
		{#if auth_state.is_authenticated_offline === true || auth_state.value === true}
			<NavBar />
		{/if}
		<div id="popover-toast" popover="auto" style="padding-top: env(safe-area-inset-top, 0px);">
			<Toasts position="top-center" />
		</div>
	</div>
</div>
